<script setup lang="ts">
import { CircleCheck, CircleX } from 'lucide-vue-next'

defineProps<{
  hasReplied?: boolean
}>()

const { t } = useI18n()
</script>

<template>
  <div>
    <BaseChip v-if="hasReplied" color="green" :text="t('pages.review.reviewPage.items.replied')">
      <template #leading>
        <CircleCheck />
      </template>
      <template #label>
        <span class="hidden md:inline">{{ t('pages.review.reviewPage.items.replied') }}</span>
      </template>
    </BaseChip>
    <BaseChip v-else color="red" :text="t('pages.review.reviewPage.items.unreplied')">
      <template #leading>
        <CircleX />
      </template>
      <template #label>
        <span class="hidden md:inline">{{ t('pages.review.reviewPage.items.unreplied') }}</span>
      </template>
    </BaseChip>
  </div>
</template>
